export default "__VITE_ASSET__Cud3GFCx__"